"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const hooks_1 = require("../utils/hooks");
const LoyaltyName = () => {
    const { i18n } = (0, hooks_1.useTranslate)();
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: i18n('loyalty.product.duration') });
};
exports.default = LoyaltyName;
